
const NotFoundPage = () => {
    return (
        <div className="mt-5">
            <div class="section-title">
                <h2>We're unable to find the page you are looking for</h2>
            </div>
            <iframe src="https://giphy.com/embed/g01ZnwAUvutuK8GIQn" width="480" height="269" style={{ "display": "block", "margin": "auto" }}
                class="giphy-embed" allowFullScreen></iframe>
        </div>
    )
};

export default NotFoundPage;